module.exports = __webpack_public_path__ + "img/样例2.7ee548cc.png";